<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-collapse-transition>
						<div v-if="isShowMoreSearch">
							<!--隐藏区域-->
						</div>
					</el-collapse-transition>
					<div class="search">
						<el-form ref="form" :model="searchParams" label-width="80px">
							<el-row>
								<el-col :span="6">
									<el-form-item label="周期">
										<el-select v-model="searchParams.type" placeholder="请选择">
											<el-option v-for="item in listType" :key="item" :label="item" :value="item">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="日期">
										<el-date-picker v-if="searchParams.type == '日报'" v-model="searchParams.day"
											type="date" placeholder="选择日期">
										</el-date-picker>
										<el-date-picker v-else-if="searchParams.type == '周报'"
											v-model="searchParams.week" type="week" format="yyyy 第 WW 周"
											placeholder="选择周">
										</el-date-picker>
										<el-date-picker v-else v-model="searchParams.month" type="month"
											placeholder="选择月">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<div class="search-btn">
									<el-button type="primary" icon="el-icon-search" @click="list">搜索</el-button>
									<el-button @click="clearSearchVal">清空</el-button>
								</div>
							</el-row>
						</el-form>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="name" label="班级名称"></el-table-column>
				<el-table-column prop="stunum" label="人数"></el-table-column>
				<el-table-column prop="cost" label="金额(单位分)"></el-table-column>
				<el-table-column prop="paytm" label="支付时间"></el-table-column>

				<!-- <el-table-column prop="updateTime" label="日期"></el-table-column>
				<el-table-column prop="name" label="线上课报名数"></el-table-column>
				<el-table-column prop="name" label="线上课营收"></el-table-column>

				<el-table-column prop="name" label="刷题报名数"></el-table-column>
				<el-table-column prop="name" label="刷题营收"></el-table-column>

				<el-table-column prop="name" label="总人数"></el-table-column>
				<el-table-column prop="name" label="总金额"></el-table-column> -->



			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import { type } from 'jquery';
import edit from './edit.vue';
import api from '@/api/online/temployeeorder/temployeeorder.js';
export default {
	name: 'tEmployeeOrder',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			listType: ['日报', '周报', '月报'],
			type: ''
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},

		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},

	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
